// @ts-nocheck
import React from 'react';
import PropTypes from 'react-proptypes';
import { Record, Feature } from '@fulcrumapp/fulcrum-core';
import cx from 'classnames';
import NavigationToolbarItem from './navigation-toolbar-item';
import PhotoGalleryView from '../media/photo-gallery-view';
import Collapse from '../../shared/collapse';
import EditorLevel from '../models/editor-level';
import {
  BackIcon, MapIcon, ThreeDotsIcon, GalleryIcon,
} from '../../icons';
import EditMenu from './edit-menu';
import { AppContext } from '../../hooks/use-app';
import DataViewSource from '../../data-view/models/data-view-source';

export default class NavigationToolbar extends React.Component {
  static propTypes = {
    source: PropTypes.instanceOf(DataViewSource),
    className: PropTypes.string,
    levels: PropTypes.arrayOf(
      PropTypes.instanceOf(EditorLevel),
    ).isRequired,
    onBackClick: PropTypes.func.isRequired,
    onCrumbClick: PropTypes.func.isRequired,
    onPrintClick: PropTypes.func.isRequired,
    onHistoryClick: PropTypes.func.isRequired,
    onDeleteClick: PropTypes.func.isRequired,
    record: PropTypes.instanceOf(Record).isRequired,
    feature: PropTypes.instanceOf(Feature),
    viewOnlyMode: PropTypes.bool.isRequired,
  };

  static contextType = AppContext;

  constructor(props, context) {
    super(props, context);

    this.state = {
      showingMenu: false,
      showPhotoGallery: false,
    };
  }

  componentWillUnmount() {
    this.removeWindowHandler();
  }

  render() {
    const { styles } = NavigationToolbar;

    const crumbs = this.props.levels.map((level, index) => (
      <NavigationToolbarItem
        key={level.id}
        level={level}
        last={index === this.props.levels.length - 1}
        onClick={this.handleClick}
      />
    ));

    const views = [];

    let index = 0;

    for (const crumb of crumbs) {
      views.push(crumb);

      if (index !== crumbs.length - 1) {
        views.push(<span
          key={`${crumb.props.level.id}-sep`}
          className={css(styles.separator)}
        >
          /
                   </span>);
      }

      ++index;
    }

    const iconStyle = {};

    if (this.props.record.form.statusField.isEnabled) {
      const statusChoice = this.props.record.form.statusField.statusForValue(this.props.record.status);

      if (statusChoice) {
        iconStyle.backgroundColor = statusChoice.color;
      }
    }

    return (
      <div className={cx(this.props.className, styles.container)}>
        <div
          style={iconStyle}
          className={css(styles.icon)}
        />
        <Collapse
          open={this.props.levels.length > 1}
          dimension="width"
        >
          <div className={css(styles.back)}>
            <div
              className={css(styles.backIcon)}
              onClick={this.props.onBackClick}
            >
              <BackIcon style={{ fill: '#01a6ff' }} />
            </div>
          </div>
        </Collapse>
        <div className={css(styles.crumbs)}>
          {views}
        </div>
        {this.renderPhotoGalleryButton()}
        {this.renderMapButton()}
        {this.renderMenuButton()}
      </div>
    );
  }

  renderMapButton() {
    if (this.currentLevel.isMapEnabled) {
      const { styles } = NavigationToolbar;
      const inset = css(this.props.mapVisible && styles.inset);
      return (
        <div
          className={css(styles.mapButton, inset)}
          title="Toggle Map"
          onClick={this.props.onMapClick}
        >
          <MapIcon className={css(!this.props.mapVisible && styles.mapButtonOff)} />
        </div>
      );
    }
    return null;
  }

  renderPhotoGalleryButton() {
    const items = this.giveMeAllThePhotosThatYouHave();

    if (this.currentLevel.isRecordLevel && this.props.record.createdAt && items.length > 0) {
      const { styles } = NavigationToolbar;

      const classes = css(styles.buttonContainer);

      return (
        <div
          className={classes}
          title="Photo Gallery"
        >
          <div
            className={css(styles.button)}
            onClick={this.handlePhotoGalleryClick}
          >
            <GalleryIcon style={{ fill: '#f00' }} height={21} width={21} />
          </div>
          <PhotoGalleryView
            source={this.props.source}
            visible={this.state.showPhotoGallery}
            mediaValueItems={items}
            record={this.props.record}
            feature={this.props.feature}
            onClose={this.handlePhotoGalleryClose}
            title={this.currentLevel.displayName || ''}
          />
        </div>
      );
    }
    return null;
  }

  renderMenuButton() {
    if (this.currentLevel.isRecordLevel && this.props.record.createdAt) {
      const { styles } = NavigationToolbar;

      const classes = css(styles.buttonContainer,
        this.state.showingMenu && styles.menuButtonShowing);

      return (
        <div
          className={classes}
          title="Menu"
          ref={this.bindMenuNode}
        >
          <div
            className={css(styles.button)}
            onClick={this.handleMenuClick}
          >
            <ThreeDotsIcon style={{ fill: '#f00' }} width="20" />
          </div>
          <EditMenu
            open={this.state.showingMenu}
            allowPrint={this.context.role.canRunReports}
            allowDelete={!this.props.viewOnlyMode && this.context.role.canDeleteRecords}
            onPrintClick={this.handlePrintClick}
            onHistoryClick={this.handleHistoryClick}
            onDeleteClick={this.handleDeleteClick}
          />
        </div>
      );
    }

    return null;
  }

  bindMenuNode = (node) => {
    this.menuNode = node;
  };

  get currentLevel() {
    return this.props.levels[this.props.levels.length - 1];
  }

  giveMeAllThePhotosThatYouHave = () => {
    const { mediaValues } = this.props.record.formValues;
    const photos = mediaValues.filter((m) => m.mediaValue && m.mediaValue.element.isPhotoElement);

    return photos;
  };

  handleClick = (item) => {
    this.props.onCrumbClick(item);
  };

  handleMenuClick = () => {
    this.toggleMenu();
  };

  handlePhotoGalleryClick = () => {
    this.setState({ showPhotoGallery: true });
  };

  handlePhotoGalleryClose = () => {
    this.setState({ showPhotoGallery: false });
  };

  handlePrintClick = () => {
    this.hideMenu();
    this.props.onPrintClick();
  };

  handleHistoryClick = () => {
    this.hideMenu();
    this.props.onHistoryClick();
  };

  handleDeleteClick = () => {
    this.hideMenu();
    this.props.onDeleteClick();
  };

  handleWindowClick = (event) => {
    if (!this.menuNode.contains(event.target)) {
      this.hideMenu();
      event.stopPropagation();
    }
  };

  addWindowHandler() {
    this.removeWindowHandler();
    window.addEventListener('click', this.handleWindowClick, { capture: true });
  }

  removeWindowHandler() {
    window.removeEventListener('click', this.handleWindowClick, { capture: true });
  }

  toggleMenu() {
    if (!this.state.showingMenu) {
      this.showMenu();
    } else {
      this.hideMenu();
    }
  }

  showMenu() {
    this.setState({ showingMenu: true }, () => {
      this.addWindowHandler();
    });
  }

  hideMenu() {
    this.setState({ showingMenu: false }, () => {
      this.removeWindowHandler();
    });
  }
}

const styles = cssInJS({
  container: {
    display: 'flex',
    flexDirection: 'row',
    position: 'relative',
    backgroundColor: '#fafafa',
    borderBottom: '1px solid #ddd',
    paddingLeft: 0,
    boxShadow: '0px -4px 50px 3px rgba(0,0,0,0.2)',
    zIndex: 1,
  },

  icon: {
    minWidth: 35,
    maxWidth: 35,
    height: 36,
    borderBottom: THEME.fieldBorderMedium,
    flex: '0 1 auto',
  },

  back: {
    borderLeft: THEME.fieldBorderMedium,
  },

  backIcon: {
    width: 36,
    minWidth: 36,
    height: 36,
    padding: 8,
    fontSize: 11,
    textAlign: 'center',
    color: THEME.linkColor,
    cursor: 'pointer',
    flex: '0 1 auto',
  },

  crumbs: {
    paddingLeft: 10,
    paddingRight: 10,
    flex: '1 1 auto',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    borderLeft: THEME.fieldBorderMedium,
    display: 'flex',
  },

  separator: {
    fontSize: 13,
    display: 'inline-block',
    paddingLeft: 6,
    minWidth: 10,
    paddingTop: 10,
    flex: '0 1 auto',
  },

  mapButton: {
    width: 48,
    minWidth: 48,
    height: 36,
    borderLeft: '1px solid #d9d9d9',
    borderBottom: '1px solid #d9d9d9',
    cursor: 'pointer',
    backgroundColor: '#fff',
    padding: '7px 13px 4px 13px',
    textAlign: 'center',
    fill: '#eb1300',
    flex: '0 1 auto',
  },

  mapButtonOff: {
    opacity: 0.2,
  },

  buttonContainer: {
    display: 'inline-block',
    position: 'relative',
    width: 48,
    minWidth: 48,
    height: 36,
    borderLeft: '1px solid #d9d9d9',
    borderBottom: '1px solid #d9d9d9',
    cursor: 'pointer',
    backgroundColor: '#fff',
    textAlign: 'center',
    fill: '#eb1300',
    userSelect: 'none',
    flex: '0 1 auto',
  },

  menuButtonShowing: {
    boxShadow: 'inset 0px 0px 8px 0px rgba(0,0,0,0.2)',
  },

  button: {
    width: 48,
    minWidth: 48,
    height: 36,
    padding: '7px 13px 4px 13px',
  },

  inset: {
    boxShadow: 'inset 0px 0px 8px 0px rgba(0,0,0,0.2)',
  },
});

NavigationToolbar.styles = styles;
